import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#009f83',
        secondary: '#53616d',
        error: '#b43d3d',
        success: '#126b52',
      },
    },
  },
});
